import {
  createStandaloneToast,
  ToastPositionWithLogical,
} from '@chakra-ui/react';

import i18n from 'i18next';

import { v4 as uuid } from 'uuid';

export interface IComponentToastProps {
  duration?: number;
  isClosable?: boolean;
  position?: ToastPositionWithLogical;
  title: string;
  type: 'info' | 'warning' | 'success' | 'error';
}

const ComponentToast = ({
  duration = 4500,
  isClosable = true,
  position = 'bottom',
  title,
  type = 'info',
}: IComponentToastProps) => {
  const toast = createStandaloneToast();
  const translatedTitle = type === 'error' ? i18n.t(`error.${title}`) : title;
  const extendedErrorDuration = type === 'error' ? 15000 : duration;

  return toast({
    id: uuid(),
    position,
    duration: extendedErrorDuration,
    status: type,
    title: translatedTitle,
    isClosable,
  });
};

export default ComponentToast;
